import React, { useContext } from "react";
import AppRoleContext from "context/AppRoleContext";
import Wrapper from "./WrapperChangeOrder";
import {
  isTeamMember,
  isHomeOwner,
  isProjectManager,
  isSupplierAdmin,
} from "core/utils/roleUtils";

const RenderChangeOrders = (props) => {
  const appRoleDetails = useContext(AppRoleContext);
  const projectUserRole = props?.projectData?.projUserRole || {};

  if (isProjectManager(appRoleDetails, projectUserRole)) {
    return <Wrapper type={"builder"} {...props} />;
  }
  if (isSupplierAdmin(appRoleDetails)) {
    return <Wrapper type={"supplier"} {...props} />;
  }
  if (isTeamMember(appRoleDetails)) {
    return <Wrapper type={"teamMember"} {...props} />;
  }
  if (isHomeOwner(appRoleDetails)) {
    return (
      <Wrapper
        type={"homeowner"}
        projectData={{
          property: props?.propertyData || {},
          company: props?.propertyData?.company || {},
        }}
        {...props}
      />
    );
  }
  return (
    <div className="change-order-page-not-found">
      Didn't have enough permission to view this Page
    </div>
  );
};

export const ChangeOrders = (props) => {
  return (
    <div className="change-orders-page">
      <RenderChangeOrders {...props} />
    </div>
  );
};
export default ChangeOrders;
